import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import { AccessLog } from "../../Utils/AccessLog";

const PendingPaymentNotice = ({ isAuthenticated }) => {
  const [hasPending, setHasPending] = useState(false);
  const [isOverdue, setIsOverdue] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      try {
        if (!isAuthenticated) {
          setHasPending(false);
          setIsOverdue(false);
          setIsBlocked(false);
          return;
        }
        const authToken = localStorage.getItem("authToken");
        const customerDetails = JSON.parse(
          localStorage.getItem("customerDetails") || "{}"
        );
        if (!customerDetails?.customerAccountId) {
          setHasPending(false);
          setIsOverdue(false);
          setIsBlocked(false);
          return;
        }

        const headers = {
          Authorization: `Bearer ${authToken}`,
        };
        const response = await apiRequest(
          `web_api/admin/fetchInvoicePaymentDetails?customer_account_id=${encryptData(
            customerDetails?.customerAccountId?.toString()
          )}`,
          "GET",
          null,
          headers
        );

        const payload = response?.data;
        const raw =
          payload?.data?.invoice_payments ??
          payload?.data ??
          payload?.invoice_payments ??
          payload;

        const list = Array.isArray(raw)
          ? raw
          : raw && typeof raw === "object"
          ? [raw]
          : [];

        const pendingItems = list.filter(
          (item) => (item?.status || "").toLowerCase() === "pending"
        );
        const pendingExists = pendingItems.length > 0;
        const hasOverdue = pendingItems.some(
          (item) => item?.due_date && new Date(item.due_date) < new Date()
        );
        const hasBlock = list.some((item) => String(item?.block_access) === "1");

        setHasPending(pendingExists);
        setIsOverdue(hasOverdue);
        setIsBlocked(hasBlock);
      } catch (err) {
        // On API error, do not block navigation; simply hide the banner
        setHasPending(false);
        setIsOverdue(false);
        setIsBlocked(false);
      }
    };

    run();
    // Re-check on every route change
  }, [location.pathname, isAuthenticated]);

  if (!hasPending && !isBlocked) return null;

  return (
    <div className="pending-payment-banner">
      <span>
        {isBlocked
          ? "Your access has been restricted due to pending payment. Please complete payment immediately to restore access."
          : isOverdue
          ? "Your payment is overdue. Please complete it as soon as possible to avoid account suspension and loss of access."
          : "You have a pending payment. Please complete it to avoid service disruptions."}
      </span>
      {!isBlocked && (
        <Link
          to="/account/payments"
          className="pending-payment-link"
          onClick={() => AccessLog("Pending Payment Banner Click")}
        >
          View Payments
        </Link>
      )}
    </div>
  );
};

export default PendingPaymentNotice;
